<style lang="scss">
    @import "project";
</style>
<template>
    <el-dialog
            title="选择项目"
           :visible.sync="dialogVisible"
           :append-to-body="true"
           width="681px"
           class="project-list global-dialog">
        <div class="project-list-body">
            <p class="p-l-tool">
                <span class="">选择项目进入成员管理</span>
                <el-button class="c-main-color" round type="default" @click="edit">{{isEdit? '取消编辑' : '编辑项目'}}</el-button>
            </p>
            <div class="p-l-body">
                <template v-for="(item, index) in projects" >
                    <div class="project-item" :key="index" v-if="isApproving(item)">
                        <img src="img/folder.png"/>
                        <span class="p-approval"><i class="el-icon-s-custom"></i>审核中</span>
                        <div class="p-name c-ellipsis">
                            <span  v-text="item.name" :title="item.name"></span>
                        </div>
                    </div>
                    <div class="project-item" :key="index" v-else>
                        <el-popover placement="bottom" title="" v-if="isEdit" :key="index"
                                width="242" popper-class="del-project-box"
                                trigger="manual" v-model="projVisible[index]">
                                <section>
                                   <main class="d-p-b-main">
                                       <i class="el-icon-warning main-icon"></i>
                                       <div class="main-content">
                                           <p class="d-p-confirm">确认将“{{item.name}}”项目删除?</p>
                                           <p class="d-p-tip">删除后所有相关数据将一并清除</p>
                                       </div>
                                   </main>
                                    <footer class="d-p-b-footer">
                                        <el-button type="default" size="mini" @click="closeDelDialog(index)">取消</el-button>
                                        <el-button type="danger" @click="delProject(item, index)" size="mini" :loading="delLoading">确定</el-button>
                                    </footer>
                                </section>
                            <a slot="reference" @click="showDelDialog(index)"><i class="el-icon-error c-main-color p-del-icon" ></i></a>
                        </el-popover>

                        <img src="img/folder.png" @click="redirectTo(item)" class="c-pointer"/>
                        <div class="p-name c-pointer c-ellipsis" @click="redirectTo(item)">
                            <el-input class="p-name-ipt" ref="input" size="small" spellcheck="false"
                                      max="10"
                                      min="1"
                                      v-model="item.name"
                                      @blur="onInputBlur(item)"
                                      v-show="item.edit"/>
                            <span  v-text="item.name" v-show="!item.edit" :title="item.name"></span>
                            <i class="iconfont icon-edit p-edit" @click.stop="setEditStatus(item, index)" v-if="!item.edit"></i>
                        </div>
                    </div>
                </template>
                <div class="project-item c-pointer"  @click="showProjectForm">
                    <div class="add-project-bg">
                        <div class="c-center">
                            <i class="el-icon-plus"></i>
                            <div class="a-p-bg-name c-pointer">添加项目</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer"></span>
        <project-form v-model="projectFormDialogVal"></project-form>
        <project-alert v-model="projectAlertVal"></project-alert>
    </el-dialog>
</template>
<script>
    import projectService from '../../request/service/project-service'
    import projectForm from './project-form'
    import projectAlert from './project-repeatition-alert'
    import {error_code_40001} from '@/const.js'
    export default {
        props: {
            value: {type: Boolean, default: false}
        },
        components: {projectForm, projectAlert},
        data () {
            return {
                isEdit: false,
                projectFormDialogVal: false,
                projectAlertVal: false,
                projVisible:{},
                delLoading: false,
            };
        },
        computed: {
            dialogVisible: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                }
            },
            projects() {
                return  this.$store.state.app.adminProjects;
            }
        },
        watch: {
            dialogVisible (v) {
                if (v) {
                    this.init();
                }
            }
        },
        methods: {
            init () {},
            edit (){
                this.isEdit = !this.isEdit;
            },
            setEditStatus (item, index) {
                if(item.hasOwnProperty('edit')) {
                    item.edit = true;
                } else {
                    this.$set(item, 'edit', true);
                }
                this.$nextTick(() =>{
                    this.$refs.input[index].focus();
                });
            },
            onInputBlur (item) {
                projectService.update(item.id, item.name).then(() => {
                    this.$message.success('更新成功');
                    item.edit = false;
                }, (error) =>{
                    if (error.code === error_code_40001) {
                        this.projectAlertVal = true;
                    }
                })
            },
            showDelDialog(index){
                let v = this.projVisible[index] === undefined ? false : this.projVisible[index];
                this.$set(this.projVisible, index, !v);
            },
            closeDelDialog(index){
                this.projVisible[index] = false;
            },
            delProject (item, index){
                let activePid = this.$store.state.app.projectId;
                if(activePid === item.id){
                    this.$message.error('当前项目正在使用，无法删除');
                    return;
                }
                this.delLoading = true;
                projectService.del(item.id).then(() => {
                    this.$message.success('删除成功');
                    this.$store.commit('app/del_admin_projects', index);
                    this.isEdit = false;
                }).finally(() => {
                    this.delLoading = false;
                });
            },
            showProjectForm () {
                this.projectFormDialogVal = true;
                // this.$emit('input', false);
            },
            redirectTo (item) {
                if (item.edit) {
                  return;
                }
                let id = item.id;
                this.$router.push({path: '/admin/userManagement', query: {projectId: id}});
                this.$emit('onChange', id);
                this.dialogVisible = false;
            },
            isApproving(item){
                return item.status === 'PENDING';
            }
        }
    }
</script>